import React, { useEffect, useRef, useState } from "react";
import "./Slider.scss";
import Button from "../../components/Button/Button";
import { PATH } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import Paginate from "../../components/Paginate/Paginate";
import medipuzzleHTTPMethods from "../../utils/medipuzzleHttp";
import toast from "../../utils/toast";
import { API_PATH } from "../../constants/medipuzzleURL";
import useFetch from "../../hooks/useFetch";
import Loader from "../../components/Loader/loader";
import SliderTable from "./Components/SliderTable";
import SliderForm from "./AddSliderForm";

type sliderDetailType = {
  page: number;
  totalPages: number;
};

const Slider = () => {
  const navigate = useNavigate();
  const [sliderDetails, setSliderDetails] = useState<sliderDetailType>();
  const [slider, setSlider] = useState<[] | any>([]);
  const [reloadPage, setReloadPage] = useState<boolean>(false);
  const [imagePreview, setImagePreview] = useState<string | null>("");

  const selectedElementRef = useRef();

  const { loading, fetchedData, fetchNewData } = useFetch();

  const getSlider = (params: object) => {
    let finalParam = {
      limit: 10
    };

    medipuzzleHTTPMethods
      .GET(API_PATH.SLIDER_LIST, { ...params, ...finalParam })
      .then(response => {
        let temp = response?.data;

        var sliderDetails = {
          page: temp?.page,
          totalPages: temp?.total_rows / temp?.limit
        };
        setSlider(temp);
        setSliderDetails(sliderDetails);
      })
      .catch(error => {
        toast.error(error.response);
      });
  };

  const handlePageChange = (page: number) => {
    getSlider({ page });
  };

  const handleDelete = data => {
    medipuzzleHTTPMethods
      .DELETE(`/slider/delete/${data?.id}/`)
      .then(response => {
        fetchNewData(API_PATH.SLIDER_LIST);
        toast.success("Slider deleted successfully");
      })
      .catch(err => {
        toast.error(err.message);
      });
  };

  useEffect(() => {
    fetchNewData(API_PATH.SLIDER_LIST, "");
  }, [fetchNewData]);

  useEffect(() => {
    setSlider(fetchedData);
  }, [fetchedData]);

  useEffect(() => {
    getSlider({});
  }, [reloadPage]);

  const handleClickUpdate = toggleModal => data => {
    const { id, ...postData } = data;

    async function pushUpdate() {
      try {
        const response = await medipuzzleHTTPMethods.PATCH_FILE(
          `/slider/update/${id}/`,
          postData
        );
        if (response.status === 200) {
          toggleModal();
          fetchNewData(API_PATH.SLIDER_LIST);
          toast.success("Slider updated successfully");
        } else {
          toast.error(new Error("Error in updating notification"));
        }
      } catch (error) {
        toast.error(error);
      }
    }
    pushUpdate();
  };

  const columns = [
    {
      Header: " ID",
      accessor: "id",
      Cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="">
            <div className="">{rowData.id}</div>
          </div>
        );
      }
    },
    {
      Header: " Title",
      accessor: "title",
      Cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="">
            <div className="">{rowData.title}</div>
          </div>
        );
      }
    },
    {
      Header: "URL",
      accessor: "url",
      Cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="url_cell">
            <p className="truncate-url">
              <a href={`${rowData?.link}`}>{rowData?.link}</a>
            </p>
          </div>
        );
      }
    },
    {
      Header: "Slug",
      accessor: "slug",
      Cell: ({ row }) => {
        const rowData = row.original;
        return (
          <div className="">
            <div className="">{rowData.slug ? rowData.slug : "-"}</div>
          </div>
        );
      }
    },
    {
      Header: "File",
      accessor: "file",
      Cell: ({ row }) => {
        const rowData = row.original;
        const fileUrl = rowData.url;

        const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fileUrl);
        const isPDF = /\.pdf$/i.test(fileUrl);

        return (
          <div
            className="file_preview_container"
            style={{ display: "flex", alignItems: "center" }}
          >
            {isImage && (
              <img
                onClick={() => setImagePreview(fileUrl)}
                src={fileUrl}
                alt="Preview"
                style={{
                  width: "150px",
                  height: "100px",
                  objectFit: "fill",
                  cursor: "pointer",
                  padding: "4px"
                }}
              />
            )}
            {isPDF && (
              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                📄 View PDF
              </a>
            )}
            {!isImage && !isPDF && (
              <span style={{ width: "80px", objectFit: "contain" }}>
                Unsupported file
              </span>
            )}
          </div>
        );
      }
    }
  ];

  return (
    <div className="slider_container">
      <h3>Slider</h3>
      <hr />

      <div className="add_button_wrapper" style={{ padding: "12px" }}>
        <Button
          buttonName="Add Slider"
          clickHandler={() => {
            navigate(PATH.ADD_SLIDER);
          }}
          color="success"
          type="button"
        />
      </div>
      {loading ? (
        <div className="pos-center">
          <Loader />{" "}
        </div>
      ) : slider?.length ? (
        <div className="">
          <SliderTable
            columns={columns}
            data={slider}
            handleClickUpdate={() => handleClickUpdate}
            handleDelete={handleDelete}
            formToEdit={<SliderForm />}
            selectedElementRef={selectedElementRef}
          />
        </div>
      ) : (
        <div className="pos-center"> No Slider at this moment. </div>
      )}

      <div className="blog_card_container">
        <div className="blogs" style={{ marginTop: "2%" }}>
          <div className="container">
            <div className="blog-cards row"></div>
            <Paginate
              handlePageChange={handlePageChange}
              pageCount={sliderDetails?.totalPages}
            />
          </div>
        </div>
      </div>
      {imagePreview && (
        <div
          onClick={() => setImagePreview(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <img
            src={imagePreview}
            alt="Full Preview"
            style={{
              maxHeight: "90vh",
              maxWidth: "90vw",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.4)"
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Slider;
